module.exports = __webpack_public_path__ + "img/stone8.78c0493d.png";